/*
 * @Author: tianzhitong laotianwy@163.com
 * @Date: 2024-02-01 13:57:28
 * @LastEditors: tianzhitong laotianwy@163.com
 * @LastEditTime: 2024-03-01 17:28:15
 * @FilePath: /ckb-official-website-fed/src/index.tsx
 * @Description:
 *
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved.
 */
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
    // eslint-disable-next-line react/react-in-jsx-scope
    <App />
);
